import { ceV2Axios } from './axios';
import {
  AwsCheckoutRequest,
  composeQuery,
  DataResponse,
  Order,
  OrderCheckoutRequest,
  OrderPreviewRequest,
  OrderPreviewResponse,
  PageableResponse,
  Query,
} from '../models';

export const checkout = async (data: OrderCheckoutRequest) => (
  await ceV2Axios.post<DataResponse<Order>>('/orders/checkout', data)
).data;

export const previewOrder = async (previewRequest: OrderPreviewRequest) => (
  await ceV2Axios.post<DataResponse<OrderPreviewResponse>>('/orders/preview', previewRequest)
).data.data;

export const fetchOrders = async (...criteria: Query<Order>[]) => (
  await ceV2Axios.get<PageableResponse<Order>>('/orders', {
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
    params: composeQuery<Order>(...criteria),
    data: {},
  })
).data.data;

export const fetchOrderById = async (orderId: number) => (
  await ceV2Axios.get<DataResponse<Order>>(`/orders/${orderId}`, {
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
  })
).data.data;

export const cancelOrder = async (orderId: number) => (
  await ceV2Axios.post<DataResponse<Order>>(`/orders/${orderId}/cancel`, orderId)
).data.data;

export const checkoutAws = async (data: AwsCheckoutRequest) => (
  await ceV2Axios.post<DataResponse<Order>>('/orders/checkout/aws', data)
).data;
